import SocioSvg from '~/icons/Socio'
import { ModalMoreInfo } from './MoreInfoModal'
import { Card } from '~/design-system/primitives'
import { useMessageMap } from '~/hooks/useCashbackMessageMap';
import { MessageGroup } from '~/type/Cashback';

type GenericCashbackCardProps = {
  messagesCard: MessageGroup[]
}

const GenericCashbackCard = ({ messagesCard }: GenericCashbackCardProps) => {
  const { getMessage } = useMessageMap(messagesCard);
  const message = getMessage('MESSAGE_003');

  return (
    <Card className={`flex mt-4  px-6 py-4 bg-white`} aria-labelledby="cashback-card" border>
      <div className="flex justify-between items-center gap-3">
        <div>
          <SocioSvg className='w-[50px]' />
          <p
            id="cashback-description"
            className="mt-2 table font-medium text-sm text-gray-100"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
        <ModalMoreInfo />
      </div>
    </Card>
  )
}

export default GenericCashbackCard
